// import { collection, addDoc } from "firebase/firestore";
// Replaced with backend API call
import API_URL from '../../../utils/api';

export default function useCreateSession({ db, auth, user, setError, setSuccess, setLoading, setSessionName, onSessionCreated }) {
  // Logic only, states are in the component
  const handleCreateSession = async (sessionName) => {
    setError("");
    setSuccess("");
    setLoading(true);
    if (!sessionName) {
      setError("Session name required.");
      setLoading(false);
      return;
    }
    try {
      const response = await fetch(`${API_URL}/api/sessions`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: sessionName,
          host: user.name,
          hostId: user.id || user.uid,
          members: [{ name: user.name, user_id: user.id || user.uid }]
        })
      });
      const result = await response.json();
      if (response.ok) {
        setSuccess("Session created!");
        setSessionName("");
        // Do NOT call onSessionCreated here. Let the component handle modal close after success.
      } else {
        setError(result.message || "Failed to create session.");
      }
    } catch (err) {
      setError("Failed to create session.");
    }
    setLoading(false);
  };
  return { handleCreateSession };
}
